import { ReactNode } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';

import { hasQueryParams } from '../../common/helpers/router.utils';

type Props = {
  title: string;
  description: string;
  canonicalUrl?: string;
  metaRobotsNode?: ReactNode;
  children?: ReactNode;
};

const MyHead: React.FC<Props> = ({
  title,
  description,
  canonicalUrl,
  metaRobotsNode,
  children,
}) => {
  let auxMetaRobotsNode: ReactNode = hasQueryParams(useRouter()) ? (
    <meta name="robots" content="noindex,nofollow" />
  ) : (
    <meta name="robots" content="index,follow" />
  );
  if (metaRobotsNode) {
    auxMetaRobotsNode = metaRobotsNode;
  }

  return (
    <Head>
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      <title>{title}</title>
      <meta name="description" content={description} />
      {auxMetaRobotsNode}
      {children}
    </Head>
  );
};

export default MyHead;
